// Translation: Two-factor authentication > Landing > Form (Turkish)
export default Object.freeze({
	form: {
		actions: {
			activate: 'Aktive et',
			reload: 'Tekrar yükle',
			skip: 'Atla'
		},
		fallback: {
			message: 'Lütfen sayfayı yeniden yükleyin'
		},
		fields: {
			code: {
				placeholder: 'Kodu gir'
			}
		},
		title: 'İki faktörlü kimlik doğrulama'
	}
})
